import React from "react";

const EmptyListItemComponent = (props: any) => {
  if (!props.emptyArr) {
    return null;
  }

  return props.emptyArr.map((item: any, index: number) => {
    if (item.empty === "loader") {
      return (
        <div
          key={`empty-${index}`}
          className={`${props.fetching ? "empty-loader" : "empty-item"}`}
          id={`empty-${index}`}
        >
          &nbsp;
        </div>
      );
    }

    return (
      <div key={`empty-${index}`} className="empty-item">
        &nbsp;
      </div>
    );
  });

}

export default EmptyListItemComponent;
